export default function audioOnlyPlayer(url, showAudioThumbnails) {
  return (url && url.match(/audio\.mp4|audio\.mp3/)) && !showAudioThumbnails && (showAudioThumbnails !== undefined && showAudioThumbnails !== null)
}
